import { Grid } from "@mui/material";
import React from "react";
import MainCard from "../../../components/MainCard";

const FailedTestsReport = () => {
  return <MainCard content={true}>Failed Tests Report - Coming Soon</MainCard>;
};

export default FailedTestsReport;
